import React, { Component } from "react";
import {
  ActivityIndicator,
  View,
  TouchableOpacity,
  Image,
  Platform,
  Text,
  RefreshControl,
} from "react-native";
import { connect } from "react-redux";

import ParallaxScrollView from "react-native-parallax-scroll-view";

import Header from "../components/Header";
import fonts from "../constants/fonts";
import PrescriptionHistoryItemDetail from "../components/PrescriptionHistoryItemDetail";
import PatientAvatarWithDetail from "../components/PatientAvatarWithDetail";
import { API } from "../helpers/axios";
import { APP_BASE_URL } from "../helpers/storage";

class PrescriptionHistoryDetailScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      refreshing: false,
      data: {},
    };
  }

  async fetchPrescriptionHistoryDetail(isInitializing) {
    if (!isInitializing) {
      this.setState({ refreshing: true });
    }

    const { id } = this.props.navigation.state.params.data;

    const {
      data: { data },
    } = await API.get(`${APP_BASE_URL}/v2/prescription/${id}`);

    this.setState({ data });
    this.setState({ refreshing: false });
  }

  async componentDidMount() {
    this.setState({ isLoading: true });
    await this.fetchPrescriptionHistoryDetail(true);
    this.setState({ isLoading: false });
  }

  render() {
    const { data } = this.props.navigation.state.params;
    const detail = this.state.data;

    return (
      <ParallaxScrollView
        ref={(ref) => {
          this.scrollRef = ref;
        }}
        backgroundColor={this.props.themeColors.primary}
        parallaxHeaderHeight={200}
        refreshControl={
          <RefreshControl
            refreshing={this.state.refreshing}
            onRefresh={async () => await this.fetchPrescriptionHistoryDetail()}
          />
        }
        renderForeground={() => (
          <View>
            <Header
              onPress={() => {
                this.props.navigation.goBack();
              }}
              position="start"
              text="Kembali"
              theme="light"
            />
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                padding: 20,
              }}
            >
              <PatientAvatarWithDetail
                cardNumber={this.props.navigation.state.params.cardNumber}
                fullName={this.props.navigation.state.params.fullName}
                gender={this.props.navigation.state.params.gender}
              />
              <TouchableOpacity
                style={{ marginStart: 20 }}
                onPress={() => this.scrollRef.scrollTo({ x: 0, y: 500 })}
              >
                <Image
                  source={require("../assets/baseline_keyboard_arrow_up_white_18dp.png")}
                />
              </TouchableOpacity>
            </View>
          </View>
        )}
      >
        <View style={{ backgroundColor: this.props.themeColors.primary }}>
          {this.state.isLoading ? (
            <View
              style={{
                backgroundColor: "#FFF",
                borderTopEndRadius:
                  Platform.OS === "android" && Platform.Version <= 26 ? 0 : 40,
                borderTopStartRadius:
                  Platform.OS === "android" && Platform.Version <= 26 ? 0 : 40,
                paddingTop: 64,
              }}
            >
              <View
                style={{
                  flex: 1,
                  justifyContent: "center",
                }}
              >
                <ActivityIndicator
                  size="large"
                  color={this.props.themeColors.primary}
                />
              </View>
            </View>
          ) : (
            <View
              style={{
                backgroundColor: "#FFF",
                borderTopEndRadius:
                  Platform.OS === "android" && Platform.Version <= 26 ? 0 : 40,
                borderTopStartRadius:
                  Platform.OS === "android" && Platform.Version <= 26 ? 0 : 40,
                paddingTop: 16,
              }}
            >
              <Text
                style={{
                  fontSize: 20,
                  ...fonts.bold,
                  color: this.props.themeColors.darkestPrimary,
                  alignSelf: "center",
                  marginBottom: 30,
                }}
              >
                Detail Pesanan
              </Text>
              <PrescriptionHistoryItemDetail
                data={data}
                navigation={this.props.navigation}
                detail={detail}
                onDestinationChange={this.props.screenProps.onDestinationChange}
              />
            </View>
          )}
        </View>
      </ParallaxScrollView>
    );
  }
}

export default connect((state) => ({
  themeColors: state.themeColors,
}))(PrescriptionHistoryDetailScreen);
